import React from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@nextui-org/react';
import { Icon } from '@iconify/react';

interface SessionWarningModalProps {
  isOpen: boolean;
  onContinue: () => void;
  onEndSession: () => void;
  warningSeconds?: number;
}

/**
 * Modal component for session timeout warning
 */
export const SessionWarningModal: React.FC<SessionWarningModalProps> = ({
  isOpen,
  onContinue,
  onEndSession,
  warningSeconds = 60,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onEndSession}
      hideCloseButton
      isDismissable={false}
      size="md"
      classNames={{
        base: 'z-[9999]',
      }}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">
              <div className="flex items-center gap-3">
                <Icon
                  icon="mdi:clock-alert-outline"
                  className="text-warning"
                  style={{ width: '24px', height: '24px' }}
                />
                <span className="text-lg font-semibold">Session About to Expire</span>
              </div>
            </ModalHeader>
            <ModalBody>
              <p className="text-default-700">
                Your session will expire in {warningSeconds} seconds. Would you like to continue
                your session?
              </p>
            </ModalBody>
            <ModalFooter>
              <Button
                color="default"
                variant="light"
                onPress={() => {
                  onEndSession();
                  onClose();
                }}
              >
                End Session
              </Button>
              <Button
                color="primary"
                onPress={() => {
                  onContinue();
                  onClose();
                }}
              >
                Continue Session
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

